import React, { useEffect, useState } from "react";
import axios from 'axios';
import Header from "../components/header";
import Footer from "../components/footer";
import download from "../assets/images/download.png";
import cricket from "../assets/images/cricket.png";
import MainSection from "../components/MainSection";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';

import { Helmet } from "react-helmet";

import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../firebaseConfig"; // adjust path if needed



const Signuppage = () => {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      navigate("/home");
    }
  }, [navigate]);

  const handleCloseErrorModal = () => setShowErrorModal(false);

  const validateInput = () => {
    if (!fullName || !emailAddress || !whatsappNumber || !password) {
      setError('All fields are required.');
      setShowErrorModal(true);
      return false;
    }
    if (!emailAddress.includes('@') || !emailAddress.includes('.')) {
      setError('Invalid email address.');
      setShowErrorModal(true);
      return false;
    }
    if (whatsappNumber.length < 7 || whatsappNumber.length > 15) {
      setError('Whatsapp number must be between 6 and 15 digits.');
      setShowErrorModal(true);
      return false;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters long.');
      setShowErrorModal(true);
      return false;
    }
    return true;
  };


  // Function to check if user exists
  const checkUserExists = async (emailOrPhone, whatsapp) => {
    const params = new URLSearchParams();
    params.append('username', emailOrPhone);
    params.append('user_whatsapp', whatsapp);
    params.append('table_name', 'users');
    params.append('fieldName', 'user_email'); // Use 'user_email' as the field to check

    try {
      const source = axios.CancelToken.source();
      const timeout = setTimeout(() => {
        source.cancel();
      }, 20000); // 20 seconds timeout

      const response = await axios.post('https://api.betprowallet.pk/app_user_check.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        cancelToken: source.token,
      });

      clearTimeout(timeout);

      // Check the response from the API
      if (response.data === 'type1 found') {
        return { exists: true, type: 'email' };
      } else if (response.data === 'type2 found') {
        return { exists: true, type: 'whatsapp' };
      } else {
        return { exists: false };
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        alert('Request timed out. Please try again.');
      } else {
        alert('Error checking user. Please check your internet connection...');
      }

      return { exists: false }; // Return false in case of any error
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateInput()) return;


    // Check if the user exists before proceeding with registration
    const checkResult = await checkUserExists(emailAddress, whatsappNumber);

    if (checkResult.exists) {
      // Notify the user if they already exist
      alert(`User with ${checkResult.type} already exists.`);
      setLoading(false);
      return;
    }



    setLoading(true);
    setError('');

    const params = new URLSearchParams();
    params.append('user_email', emailAddress);
    params.append('user_whatsapp', whatsappNumber);
    params.append('user_fullname', fullName);
    params.append('user_real_pass', password);
    params.append('table_name', 'users');

    try {
      const source = axios.CancelToken.source();
      const timeout = setTimeout(() => {
        source.cancel();
      }, 20000); // 20 seconds timeout

      const response = await axios.post('https://api.betprowallet.pk/createNewAccUserFromServer.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        cancelToken: source.token,
      });

      clearTimeout(timeout);

      // console.log('Response data:', response.data);

      if (response.data.status === 'success') {


        localStorage.removeItem('user');

        const user = {
          name: response.data.data[0]?.user_fullname || 'User',
          bp_username: response.data.data[0]?.user_betpro_username || '',
          bp_pass: response.data.data[0]?.user_betpro_password || '',
          email: response.data.data[0]?.user_email || '',
          password: '',
          number: response.data.data[0]?.user_whatsapp || 'N/A',
          userID: response.data.data[0]?.user_id || 'N/A',
          userActive: response.data.data[0]?.user_active || 0,
          withdrawAmount: response.data[0]?.withdraw_amount || 25000,
        };



        localStorage.setItem('user', JSON.stringify(user));



        // console.log('User data:', response.data.data[0]);
        navigate('/home');




      } else {
        setError(response.data.message || 'Sign up failed. Please try again.');
        setShowErrorModal(true);
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setError('Request timed out. Please try again.');
      } else {
        setError('Please check your internet connection...');
      }
      setShowErrorModal(true);
    }


    finally {
      setLoading(false);
    }
  };

  const handlebuttonClick = () => {
    navigate('/');
  };


  // Helper: Detect if user is inside WebView
  const isWebView = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /wv|WebView|; wv/.test(userAgent);
  };

  const handleGoogleLogin = async () => {
    if (isWebView()) {
      console.log("Detected WebView → using native Google sign-in");
     window.ReactNativeWebView?.postMessage(
  JSON.stringify({ action: "googleLogin", mode: "signup" })
);
      // The WebView app will intercept this message and handle login natively.
    } else {
      console.log("Detected Browser → using web OAuth flow");

      setLoading(true);
      setError('');


      try {
        const provider = new GoogleAuthProvider();

        // 👇 Force showing the account selection popup every time
        provider.setCustomParameters({
          prompt: "select_account",
        });

        const result = await signInWithPopup(auth, provider);
        const user = result.user;


        setLoading(true);
        setError('');

        try {
          // Check if an account already exists for this Google email before
          // trying to create a new one — avoids the "already have user" dead end
          // when someone lands on Signup but already has an account.
          const loginParams = new URLSearchParams();
          loginParams.append('username', user.email);
          loginParams.append('fieldName', 'user_email');
          loginParams.append('table_name', 'users');

          const loginSource = axios.CancelToken.source();
          const loginTimeout = setTimeout(() => {
            loginSource.cancel();
          }, 20000); // 20 seconds timeout

          const loginResponse = await axios.post('https://api.betprowallet.pk/loginUserApi_ft.php', loginParams, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            cancelToken: loginSource.token,
          });

          clearTimeout(loginTimeout);

          const existingUserFound =
            Array.isArray(loginResponse.data) && loginResponse.data.length > 0;

          if (existingUserFound) {
            // Account already exists — log the user in instead of creating a duplicate
            localStorage.removeItem('user');

            const existingUser = {
              name: loginResponse.data[0]?.user_fullname || 'User',
              bp_username: loginResponse.data[0]?.user_betpro_username || '',
              bp_pass: loginResponse.data[0]?.user_betpro_password || '',
              email: loginResponse.data[0]?.user_email || '',
              password: '',
              number: loginResponse.data[0]?.user_whatsapp || 'N/A',
              userID: loginResponse.data[0]?.user_id || 'N/A',
              userActive: loginResponse.data[0]?.user_active || 0,
              withdrawAmount: loginResponse.data[0]?.withdraw_amount || 25000,
            };

            localStorage.setItem('user', JSON.stringify(existingUser));
            navigate('/home');
            setLoading(false);
            return;
          }

          const params = new URLSearchParams();
          params.append('user_email', user.email);
          params.append('user_whatsapp', user.phoneNumber || "UNKNOWN");
          params.append('user_fullname', user.displayName);
          params.append('user_real_pass', user.uid);
          params.append('table_name', 'users');

          const source = axios.CancelToken.source();
          const timeout = setTimeout(() => {
            source.cancel();
          }, 20000); // 20 seconds timeout

          const response = await axios.post('https://api.betprowallet.pk/createNewAccUserFromServer.php', params, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            cancelToken: source.token,
          });

          clearTimeout(timeout);

          // console.log('Response data:', response.data);

          if (response.data.status === 'success') {


            localStorage.removeItem('user');

            const user = {
              name: response.data.data[0]?.user_fullname || 'User',
              bp_username: response.data.data[0]?.user_betpro_username || '',
              bp_pass: response.data.data[0]?.user_betpro_password || '',
              email: response.data.data[0]?.user_email || '',
              password: '',
              number: response.data.data[0]?.user_whatsapp || 'N/A',
              userID: response.data.data[0]?.user_id || 'N/A',
              userActive: response.data.data[0]?.user_active || 0,
              withdrawAmount: response.data[0]?.withdraw_amount || 25000,
            };



            localStorage.setItem('user', JSON.stringify(user));



            // console.log('User data:', response.data.data[0]);
            navigate('/home');




          } else {
            setError(response.data.message || 'Sign up failed. Please try again.');
            setShowErrorModal(true);
          }
        } catch (error) {
          if (axios.isCancel(error)) {
            setError('Request timed out. Please try again.');
          } else {
            setError('Please check your internet connection...');
          }
          setShowErrorModal(true);
        }


        finally {
          setLoading(false);
        }








        //   console.log("Google user data:", user);
        // 🔹 You can now send userData to your backend API (signup/login)
      } catch (error) {
        setLoading(false)
         setError('Request timed out. Please try again.');
              setShowErrorModal(true);
                  
        //   console.error("Google sign-in error:", error);
      }
    }
  };

useEffect(() => {
  const handleMessage = async (event) => {

    console.log("🔥 REACT RECEIVED RAW:", event.data);

    let data = null;

    // ✅ CASE 1: Android sent JS object
    if (typeof event.data === "object" && event.data !== null) {
      data = event.data;
    }

    // ✅ CASE 2: Android / others sent JSON string
    else if (typeof event.data === "string") {

      // Ignore Firebase internal messages like "!_{}"
      if (!event.data.trim().startsWith("{")) {
        console.log("⏭ Ignored non-JSON string");
        return;
      }

      try {
        data = JSON.parse(event.data);
      } catch (e) {
        console.log("⏭ JSON parse failed");
        return;
      }
    }

    if (!data?.email || !data?.uid) {
      console.log("⏭ Missing required fields");
      return;
    }

    console.log("✅ ANDROID USER DATA:", data);

    try {

      /* ===========================
         🔐 LOGIN
      =========================== */
      if (data.mode === "login") {
        const params = new URLSearchParams();
        params.append("username", data.email);
        params.append("fieldName", "user_email");
        params.append("table_name", "users");

        const response = await axios.post(
          "https://api.betprowallet.pk/loginUserApi_ft.php",
          params,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        if (response.data && response.data[0]) {
          const user = {
            name: response.data[0].user_fullname,
            bp_username: response.data[0].user_betpro_username,
            bp_pass: response.data[0].user_betpro_password,
            email: response.data[0].user_email,
            number: response.data[0].user_whatsapp,
            userID: response.data[0].user_id,
            userActive: response.data[0].user_active,
            withdrawAmount: response.data[0].withdraw_amount || 25000,
          };

          localStorage.setItem("user", JSON.stringify(user));
          navigate("/home");
          return;
        }

        setError("User not found");
        setShowErrorModal(true);
        return;
      }

      /* ===========================
         📝 SIGNUP
      =========================== */
      if (data.mode === "signup") {
        // Check if an account already exists for this email before creating
        // a new one — avoids the "already have user" dead end.
        const loginParams = new URLSearchParams();
        loginParams.append("username", data.email);
        loginParams.append("fieldName", "user_email");
        loginParams.append("table_name", "users");

        const loginResponse = await axios.post(
          "https://api.betprowallet.pk/loginUserApi_ft.php",
          loginParams,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        if (Array.isArray(loginResponse.data) && loginResponse.data.length > 0) {
          const u = loginResponse.data[0];
          const user = {
            name: u.user_fullname,
            bp_username: u.user_betpro_username,
            bp_pass: u.user_betpro_password,
            email: u.user_email,
            number: u.user_whatsapp,
            userID: u.user_id,
            userActive: u.user_active,
            withdrawAmount: u.withdraw_amount || 25000,
          };

          localStorage.setItem("user", JSON.stringify(user));
          navigate("/home");
          return;
        }

        const params = new URLSearchParams();
        params.append("user_email", data.email);
        params.append("user_whatsapp", "UNKNOWN");
        params.append("user_fullname", data.name || "User");
        params.append("user_real_pass", data.uid);
        params.append("table_name", "users");

        const response = await axios.post(
          "https://api.betprowallet.pk/createNewAccUserFromServer.php",
          params,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        if (response.data?.status === "success") {
          const u = response.data.data[0];

          const user = {
            name: u.user_fullname,
            bp_username: u.user_betpro_username,
            bp_pass: u.user_betpro_password,
            email: u.user_email,
            number: u.user_whatsapp,
            userID: u.user_id,
            userActive: u.user_active,
            withdrawAmount: u.withdraw_amount || 25000,
          };

          localStorage.setItem("user", JSON.stringify(user));
          navigate("/home");
          return;
        }

        setError(response.data?.message || "Signup failed");
        setShowErrorModal(true);
      }

    } catch (err) {
      console.error("❌ Google Auth API Error:", err);
      setError("Something went wrong. Please try again.");
      setShowErrorModal(true);
    }
  };

  console.log("✅ React listener mounted");

  document.addEventListener("message", handleMessage);
  window.addEventListener("message", handleMessage);

  return () => {
    document.removeEventListener("message", handleMessage);
    window.removeEventListener("message", handleMessage);
  };
}, []);



  return (
    <div>

      <Helmet>
        {/* Page title optimized with relevant keywords */}
        <title>Betpro Wallet Signup - Bpexch</title>
        <link rel="icon" href="https://betprowallet.pk/favicon.ico" />

        {/* Canonical tag */}
        <link rel="canonical" href="https://betprowallet.pk/signup" />

        {/* Meta description summarizing the page content */}
        <meta name="description" content="Betpro Wallet Pakistan registration. ⚽️ Register your Betpro Wallet account by phone number and claim a sign-up bonus. ✓ Create your account now and start betting on sports with Betprowallet.pk. Secure and fast registration process." />

        {/* Meta keywords targeting search queries related to registration */}
        <meta name="keywords" content="Betpro Wallet sign up, Betpro account, Betpro app, Bpexch, Bpexch wallet, Betpro exchange, Betpro Wallet registration, create Betpro Wallet account, sign up bonus, register Betpro Wallet Pakistan, Betpro Wallet phone registration, online betting platform, Betprowallet.pk sign up" />

        {/* Meta author */}
        <meta name="author" content="Betpro Wallet" />

        {/* Open Graph meta tags for social media */}
        <meta property="og:title" content="Betpro Wallet Signup - Bpexch" />
        <meta property="og:description" content="Register for Betpro Wallet in Pakistan and claim your sign-up bonus. Create your account today and start betting on sports with secure and fast withdrawals." />
        <meta property="og:url" content="https://betprowallet.pk/signup" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://betprowallet.pk/bpthumb1.jpg" />

        {/* Twitter Card for social sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Betpro Wallet Signup - Bpexch" />
        <meta name="twitter:description" content="Sign up for Betpro Wallet in Pakistan. Get a sign-up bonus and start betting on your favorite sports. Secure, fast, and easy registration process." />
        <meta name="twitter:image" content="https://betprowallet.pk/images/signup-twitter-image.jpg" />

        {/* Structured Data for SEO */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Betpro Wallet Signup - Bpexch",
        "url": "https://betprowallet.pk/signup",
        "description": "Betpro Wallet registration page. Create an account and get a sign-up bonus to start betting on sports today. Secure and fast registration process in Pakistan.",
        "publisher": {
          "@type": "Organization",
          "name": "Betpro Wallet"
        }
      }
    `}
        </script>
      </Helmet>

      <Header />



      <div className="register-wrapper2">
        <div className="main-register">
          <div className="container" style={{ padding: "0 1rem", maxWidth: "28rem" }}>
            <div className="row align-items-top">
              <div className="col-md-12">
                <div className="left-register-box">
                  <div className="fieldset" style={{
                    padding: '10px 0px',
                  }}>
                    <div className="title mb-5">
                      <h1>Register Your Betpro Account - BetPro & Bpexch Wallet</h1>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-12">
                        <div className="inputs field-container">
                          <form onSubmit={handleSubmit}>
                            <input
                              type="text"
                              // className="mb-4"
                              placeholder="Full Name"
                              value={fullName}
                              onChange={(e) => setFullName(e.target.value)}
                            />
                            <input
                              type="text"
                              // className="mb-4"
                              placeholder="Email Address"
                              value={emailAddress}
                              onChange={(e) => setEmailAddress(e.target.value)}
                            />
                            <input
                              type="number"
                              // className="mb-4"
                              placeholder="Whatsapp Number"
                              value={whatsappNumber}
                              onChange={(e) => setWhatsappNumber(e.target.value)}
                            />
                            <input
                              type="password"
                              // className="mb-4"
                              placeholder="Enter password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            <button type="submit" className="btn-signin mb-3" disabled={loading}>
                              {loading ? 'Loading...' : 'Sign up'}
                            </button>
                          </form>
                          <a href="/" className="signup mb-3">
                            Already have an account?
                          </a>
                          <button className="btn-create-account mb-3" onClick={handlebuttonClick}>
                            Sign in
                          </button>

                          <button className="btn-google-login" onClick={handleGoogleLogin}>
                            <img
                              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                              alt="Google logo"
                              className="google-icon"
                            />
                            Continue with Google
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MainSection />
      <Footer />
      <Modal show={showErrorModal} onHide={handleCloseErrorModal} centered>
        <Modal.Header >
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{error}</p>
          <hr />
          <p onClick={handleCloseErrorModal} className="model-ok">Ok</p>
        </Modal.Body>

      </Modal>
    </div>
  );
};

export default Signuppage;
